import Vue from 'vue'
import VueRouter from 'vue-router'
import { getCache } from '../utils'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect:'/home/province'
  },
  {
    path: '/home',
    name: 'home-page',
    redirect: '/home/map',
    component: () => import("@/pages/home"),
    children: [
      {
        path: 'map',
        name:"home-map",
        component: () => import("@/pages/map"),
        meta: {
          title: "地图可视化"
        },
      },
      {
        path: 'province',
        name: "home-province",
        component: () => import("@/pages/province"),
        meta: {
          title: "省级地图"
        },
      }
    ]
  },
  {
    path: '/operation',
    name: "operation",
    component: () => import("@/pages/operation"),
    meta: {
      title: "运营数据"
    },
  },
  {
    path: '/car',
    name: "car",
    component: () => import("@/pages/car"),
    meta: {
      title: "今日车辆"
    },
  },
  {
    path: '/car-video',
    name: "video",
    component: () => import("@/pages/car-video"),
    meta: {
      title: "车辆实时影像"
    },
  },
  {
    path: '/vehicle-cluster',
    name: "vehicle-cluster",
    component: () => import("@/pages/vehicle-cluster"),
    meta: {
      title: "车辆操控集群"
    },
  },
  {
    path: '/vehicle-patrol',
    name: "vehicle-patrol",
    component: () => import("@/pages/vehicle-patrol"),
    meta: {
      title: "车辆巡查"
    },
  },
  {
    path: '/task',
    name: "task",
    component: () => import("@/pages/task"),
    meta: {
      title: "今日任务"
    },
  },
  {
    path: '/warn',
    name: "warn",
    component: () => import("@/pages/warn"),
    meta: {
      title: "今日告警信息"
    },
  },
  {
    path: '/login',
    name: 'login-page',
    component: () => import("@/pages/login"),
    meta: {
      title: "登录",
    },
  }
]

const router = new VueRouter({routes})

router.beforeEach((to, from, next) => {
  const token = getCache("xczn_monito_token")
  const path = to.path
  document.title = '广州星程智能科技有限公司-车辆监控中心'
  if (token) {
    if (path != '/login') {
      next()
    } else {
      next({ path: '/home/province' })
    }
  } else {
    if (path == '/login') {
      next()
    } else {
      next({ path: '/login' })
    }
  }
})

export default router
